// libraries
import { getAll as getAllAldotMessages } from "~/store/algo-api/slices/aldot-messages";
// hooks & context
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { usePrevious } from "@algo/hooks";
import { minuteToMilli } from "@caps-mobile/date-time";
import { EATAudience } from "@algo/network-manager/models/v3";

export const useALDOTMessageData = () => {
    const dispatch = useDispatch();

    const settingsStore: any = useSelector((state: any) => state.settings); // Getting refresh interval from settings
    const aldotMessageStore: any = useSelector( (state: any) => state["aldot-message"]);
    const checksum = aldotMessageStore.lastChecksum;
    const prevChecksum = usePrevious(checksum);

    useEffect(() => {
        // Get the refresh interval (default to 5 minutes if not set)
        const interval = settingsStore.refreshInterval || minuteToMilli(5);

        const fetchData = () => {
            if (!checksum || checksum !== prevChecksum) {
                dispatch(getAllAldotMessages(EATAudience.Video, false)); // GET request for new data
            }
        };

        fetchData();

        // Set up interval for checksum checking
        const timeoutId = setInterval(() => {
            dispatch(getAllAldotMessages(EATAudience.Video, true)); // HEAD request
        }, interval);

        return () => clearInterval(timeoutId); // Cleanup on unmount
    }, [checksum, settingsStore.refreshInterval]); // Dependencies
};